import { render } from "./PrintPreview.vue?vue&type=template&id=32c881cc&scoped=true&ts=true"
import script from "./PrintPreview.vue?vue&type=script&lang=ts"
export * from "./PrintPreview.vue?vue&type=script&lang=ts"

import "./PrintPreview.vue?vue&type=style&index=0&id=32c881cc&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c881cc"]])

export default __exports__